import request from "superagent";

let GOOGLE_API_KEY = "AIzaSyCZp_hyVSDgb8VfPuLR0EKwDcfPk8GkJh0";
let CALENDAR_NAME = "6lr2ihkmi7sgobfdntbrc16d7g@group.calendar.google.com";
let GOOGLE_CALENDAR_URL = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_NAME}/events?orderBy=startTime&singleEvents=true&key=${GOOGLE_API_KEY}`;

export function getEvents(callback) {
    
    request.get(GOOGLE_CALENDAR_URL).end((err, resp) => {
        if (!err) {
            const events = [];
            JSON.parse(resp.text).items.map(event => {
                return events.push({
                    start: new Date(event.start.dateTime),
                    end: new Date(event.end.dateTime),
                    title: event.summary
                });
        });
        callback(events);
        }
    });
}